// -- copyright
// OpenProject is a project management system.
//
// ++

import { Injectable, Injector } from '@angular/core';
import { OpModalService } from 'core-components/op-modals/op-modal.service';
import { SignatureEditModalComponent, SignatureEditModalData } from './signature-edit-modal.component';

@Injectable()
export class SignatureEditModalService {
  constructor(
    private opModalService: OpModalService,
    private injector: Injector
  ) {}

  /**
   * 打开签名编辑弹窗
   * @param siteDiaryId Site Diary ID
   * @param projectId 项目 ID
   * @param currentSignatures 当前签名数据
   * @param onSuccess 成功回调
   * @returns Modal 实例
   */
  show(
    siteDiaryId: number,
    projectId: string,
    currentSignatures?: SignatureEditModalData['currentSignatures'],
    onSuccess?: () => void
  ): SignatureEditModalComponent {
    return this.opModalService.show(
      SignatureEditModalComponent,
      this.injector,
      {
        siteDiaryId,
        projectId,
        currentSignatures,
        onSuccess
      }
    );
  }
}
